export default __webpack_public_path__ + "static/media/dieppe5.59cd40c6.jpg";